import { TUI_FIRST_DAY, TUI_LAST_DAY } from "@taiga-ui/cdk";
import { EKwikUIInputDateSize } from "./input-date.definitions";

export const DEFAULT_VALUES = {
  disabled: false,
  focus: false,
  formControlName: "form_control_input",
  id: "input",
  invalid: false,
  isShowLabelOutside: false,
  label: "Input",
  hintContent: "",
  icon: "",
  max: {},
  maxCalculatedFromToday: {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
    day: new Date().getDate()
  },
  min: {},
  minCalculatedFromToday: {
    year: 0,
    month: 0,
    day: 1
  },
  placeholder: "Please enter input",
  postfix: "",
  prefix: "",
  size: EKwikUIInputDateSize.L
};

export const VALIDATE_KEY_VALUES = {
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  isShowLabelOutside: true,
  label: true,
  max: true,
  maxCalculatedFromToday: true,
  min: true,
  minCalculatedFromToday: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  size: true
};
